module.exports = {
          srcSet: "/_next/static/images/img-immobilier@2x-160-990e25b95c75660d801c46828a3bf2fc.jpg"+" 160w"+","+"/_next/static/images/img-immobilier@2x-292-49fd88fea59c844f6d6f9d611faeb942.jpg"+" 292w",
          images:[ {path: "/_next/static/images/img-immobilier@2x-160-990e25b95c75660d801c46828a3bf2fc.jpg",width: 160,height: 137},{path: "/_next/static/images/img-immobilier@2x-292-49fd88fea59c844f6d6f9d611faeb942.jpg",width: 292,height: 250}],
          src: "/_next/static/images/img-immobilier@2x-160-990e25b95c75660d801c46828a3bf2fc.jpg",
          toString:function(){return "/_next/static/images/img-immobilier@2x-160-990e25b95c75660d801c46828a3bf2fc.jpg"},
          placeholder: undefined,
          width: 160,
          height: 137
      }